<template>
    <header
        class="package-summary"
        aria-label="Package summary"
    >
        <KEyebrow
            v-if="category"
            variant="pill"
            class="package-summary__category"
        >
            {{ category }}
        </KEyebrow>

        <h1 class="package-summary__title k-heading-2">
            {{ title }}
        </h1>

        <p
            v-if="subtitle"
            class="package-summary__subtitle"
        >
            {{ subtitle }}
        </p>

        <div class="package-summary__meta">
            <span v-if="duration">
                <Icon name="tabler:clock" /> {{ duration }}
            </span>
            <strong v-if="fromPriceLabel">{{ fromPriceLabel }}</strong>
        </div>

        <div class="package-summary__actions">
            <KButton
                type="button"
                label="Plan This Holiday"
                @click="emit('plan')"
            />
            <KButton
                v-if="whatsappHref"
                as="a"
                variant="secondary"
                :href="whatsappHref"
                target="_blank"
                rel="noopener"
                label="Ask an Expert"
                @click="emit('askExpert')"
            >
                <template #icon-start>
                    <Icon name="tabler:brand-whatsapp" />
                </template>
            </KButton>
        </div>
    </header>
</template>

<script setup>
import { KButton, KEyebrow } from '@vemedia/karibu'

defineProps({
    title: {
        type: String,
        required: true,
    },
    subtitle: {
        type: String,
        default: '',
    },
    duration: {
        type: String,
        default: '',
    },
    category: {
        type: String,
        default: '',
    },
    fromPriceLabel: {
        type: String,
        default: '',
    },
    whatsappHref: {
        type: String,
        default: '',
    },
})

const emit = defineEmits(['plan', 'askExpert'])
</script>

<style lang="scss" scoped>
// Deliberately not sticky. The persistent call to action is the sticky bar at the bottom
// of the page (`package-sticky-cta.vue`); pinning this block as well meant two bands
// following the reader down, and it forced the sidebar widget to hard-code an offset to
// clear it.
.package-summary {
    margin-block: var(--space-4) var(--space-5);

    &__category {
        margin-block-end: var(--space-3);
    }

    &__title {
        margin: 0;
    }

    &__subtitle {
        margin: var(--space-2) 0 0;
        color: var(--color-text-muted);
        font-size: var(--font-size-3);
    }

    &__meta {
        display: flex;
        flex-wrap: wrap;
        gap: var(--space-4);
        margin-block-start: var(--space-3);
        color: var(--color-text-muted);
        font-size: var(--font-size-2);

        span {
            display: inline-flex;
            align-items: center;
            gap: var(--space-1);
        }

        strong {
            color: var(--color-text);
        }
    }

    &__actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: var(--space-3);
        margin-block-start: var(--space-4);
    }
}
</style>
